import "chartjs-adapter-moment";
import Chart from "chart.js/auto";
import chartjsPluginAnnotation from "chartjs-plugin-annotation";
Chart.register(chartjsPluginAnnotation);